"use client";

import React from "react";
import { MapPin, Phone, Mail, Map } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
const locations = [{
  id: 1,
  name: "Apex IT Solutions HQ",
  address: "23 Collins St, Ceduna SA 5690",
  phone: "0468039299",
  email: "hello@apexitsolutions.au",
  type: "primary",
  x: "50%",
  y: "50%"
}];
export default function OurHeadquarters() {
  return <section data-section-id="222923" id="our-headquarters" className="w-full bg-background py-16 md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center">
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl mb-4">
            Our Global Presence
          </h2>
          <p className="mx-auto max-w-2xl text-lg text-muted-foreground font-default">
            Strategically positioned to deliver premium IT solutions, cybersecurity, and AI automation across South Australia and beyond.
          </p>
        </div>

        <div className="mx-auto w-full max-w-[1400px]">
          <div className="relative overflow-hidden rounded-md border border-border/10 bg-card/40 backdrop-blur-md shadow-2xl shadow-black/50">
            <AspectRatio ratio={21 / 9} className="relative w-full bg-background">
              {}
              <div className="absolute inset-0 bg-primary/5 mix-blend-overlay"></div>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687829/img/ceduna_tech_grid_map.png" alt="Apex IT Solutions Headquarters Map" className="absolute inset-0 h-full w-full object-cover opacity-30 grayscale invert" />

              {}
              {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10 -translate-x-1/2 -translate-y-1/2" style={{
              left: loc.x,
              top: loc.y
            }}>
                  <Popover>
                    <PopoverTrigger asChild>
                      <Button variant={loc.type === "primary" ? "default" : "secondary"} size="icon" className={`relative size-10 rounded-md shadow-lg transition-transform hover:scale-110 md:size-12 ${loc.type === "primary" ? "bg-primary text-primary-foreground ring-4 ring-primary/30" : "bg-secondary text-secondary-foreground ring-4 ring-secondary/30"}`} aria-label={`View ${loc.name} details`}>
                        <MapPin className="size-5 md:size-6" />
                        {loc.type === "primary" && <span className="absolute inset-0 -z-10 animate-ping rounded-md bg-primary opacity-40"></span>}
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent side="top" align="center" sideOffset={12} className="w-80 border-border/20 bg-popover/90 backdrop-blur-xl p-5 shadow-3xl">
                      <div className="space-y-4">
                        <h4 className="font-default flex items-center gap-2 border-b border-border/20 pb-3 text-lg font-semibold text-foreground">
                          <Map className={`size-5 shrink-0 ${loc.type === "primary" ? "text-primary" : "text-secondary"}`} />
                          {loc.name}
                        </h4>
                        <div className="space-y-3 font-mono text-xs uppercase tracking-wider">
                          <div className="flex items-start gap-3 text-muted-foreground">
                            <MapPin className="mt-0.5 size-4 shrink-0 text-primary" />
                            <span className="leading-snug">{loc.address}</span>
                          </div>
                          <div className="flex items-center gap-3 text-muted-foreground">
                            <Phone className="size-4 shrink-0 text-primary" />
                            <span>{loc.phone}</span>
                          </div>
                          <div className="flex items-center gap-3 text-muted-foreground">
                            <Mail className="size-4 shrink-0 text-primary" />
                            <span>{loc.email}</span>
                          </div>
                        </div>
                      </div>
                    </PopoverContent>
                  </Popover>
                </div>)}

              {}
              <div className="absolute bottom-6 left-6 z-20 hidden md:block">
                <div className="rounded-md border border-white/10 bg-white/5 p-4 backdrop-blur-lg shadow-xl">
                  <p className="font-mono text-[10px] uppercase tracking-widest text-primary mb-1">Headquarters</p>
                  <p className="font-default text-sm font-medium text-foreground">23 Collins St, Ceduna SA 5690</p>
                </div>
              </div>
            </AspectRatio>
          </div>
        </div>
      </div>
    </section>;
}